<ng-container *transloco="let t">

  <ng-container *ngIf="!okService.billing.plan.comms_active">
    <div class="alert alert-warning" role="alert">
      <i class="fa-solid fa-triangle-exclamation text-danger"></i> 

      @if(okService.billing.plan.account_type == "Pricing2024"){
        {{ t('To use start/end shift reminders you must have the Automated Plan for your account. To set up a automated plan please go to your') }} <a routerLink="/account/account">{{ t('Account Settings') }}</a>.
      }@else{
        {{ t('To use start/end shift reminders you must have the Comms Plan for your account. To set up a comms plan please go to your') }} <a routerLink="/account/account">{{ t('Account Settings') }}</a>.
      }
      
    </div>
    <p><i class="fa-solid fa-circle-info text-info"></i> {{ t('Learn more about Start/End shift reminders') }} - <a href="https://okalone.zendesk.com/hc/en-gb/articles/35908047510161-Start-and-End-Shift-Reminders" target="_new">{{ t('Click here') }}</a>.</p>
  </ng-container>




  <ng-container *ngIf="okService.billing.plan.comms_active">


    <div class="btn-group mb-2 " role="group">
    <button type="button" class="btn btn-outline-dark" data-bs-toggle="modal" data-bs-target="#settingsModal" *ngIf="!okService.isExtendedPrivacy()">
      <i class="fa-solid fa-gears"></i> {{ t('Change Start/End Shift Settings') }}
    </button>
    <button type="button" class="btn btn-outline-dark" data-bs-toggle="modal" data-bs-target="#batchModal">
      <i class="fa-solid fa-user-clock"></i> {{ t('Add Multiple Start/End Times') }}
    </button>
    <button type="button" class="btn btn-outline-dark" data-bs-toggle="modal" data-bs-target="#copyModal" *ngIf="!okService.isExtendedPrivacy()">
      <i class="fa-solid fa-copy"></i> {{ t('Copy Start/End to Workers/Groups') }}
    </button>
    </div>

    <a href="https://okalone.zendesk.com/hc/en-gb/articles/35908047510161-Start-and-End-Shift-Reminders"  class="btn btn-primary float-end" target="_new"><i class="fa fa-question-circle" aria-hidden="true"></i>  {{ t('Start/End Shift Help') }}</a>



    <p>{{ t('You can now set the times when a worker should start and end their shift. If they miss the start time they will get an email and SMS reminding them to start their shift. They will also be alerted by the same method if they do not end their shift on time.') }}</p>

    <p><i class="fa-solid fa-circle-info text-info"></i> {{ t('Click on a day or time to edit the') }} <span class="badge bg-success text-white">{{ t('Start') }}</span>/<span class="badge bg-warning text-white">{{ t('End') }}</span> {{ t('shift times for that day:') }}</p>

  <full-calendar [deepChangeDetection]="deepChangeDetection" [options]="calendarOptions"></full-calendar>


  <!-- Modal -->
  <div class="modal fade" id="editDayModal" tabindex="-1" aria-labelledby="editDayModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editLoopModalLabel">{{ t('Day Shift Settings for') }} {{edit_day_str}}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
              <form [formGroup]="dayGroup" cForm (ngSubmit)="submitDayForm()">

                  <div class="form-group row mb-2" >
                    <label class="col-sm-4 col-form-label text-end"> {{ t('Start Shift') }}</label>
                    <div class="col-sm-8">
                      <ng-select [items]="day_hours"
                      bindLabel="name"
                      bindValue="value"
                      formControlName="start">
                    </ng-select>
                    </div>
                  </div>

                  <div class="form-group row mb-2" >
                    <label class="col-sm-4 col-form-label text-end"> {{ t('End Shift') }}</label>
                    <div class="col-sm-8">
                      <ng-select [items]="day_hours"
                      bindLabel="name"
                      bindValue="value"
                      formControlName="end">
                    </ng-select>
                    </div>
                  </div>

                <button cButton class="px-4 text-white btn-info" type="submit">
                  <i class="fa-solid fa-check"></i> {{ t('Update Start/End Times') }}
                </button>
            </form>
          </div>
        </div>
      </div>
    </div>


  <!-- Modal -->
  <div class="modal fade" id="settingsModal" tabindex="-1" aria-labelledby="settingsModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="settingsModalLabel">{{ t('Change Start/End Shift Settings') }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body" *ngIf="settingGroup">

          <div class="alert alert-warning" role="alert">
            <p><b>{{ t('Important!') }}</b> {{ t('These changes are applied to every worker.') }}</p>
          </div>
          <form [formGroup]="settingGroup" cForm (ngSubmit)="submitSettingForm()">

            <div class="form-group row mb-2" >
              <label class="col-sm-4 col-form-label text-end"> {{t('Delay for missed Start/End Shift alert') }}</label>
              <div class="col-sm-8">
                <ng-select [items]="startshift_time_items"
                bindLabel="name"
                bindValue="value"
                formControlName="startshift_time">
              </ng-select>
              </div>
            </div>

            <div class="form-group row mb-2" >
              <label class="col-sm-4 col-form-label text-end"> {{ t('Send Start/End Shift alert to monitor?') }}</label>
              <div class="col-sm-8">
                <ng-select [items]="startshift_monitor_items"
                bindLabel="name"
                bindValue="value"
                formControlName="startshift_monitor">
              </ng-select>
              </div>
            </div>

            <div class="form-group row mb-2" >
              <label class="col-sm-4 col-form-label text-end"> {{ t('Send Worker Reminder using:') }}</label>
              <div class="col-sm-8">
                <ng-select [items]="startshift_method_items"
                bindLabel="name"
                bindValue="value"
                [multiple]="true"
                formControlName="startshift_method">
              </ng-select>
              <p>{{ t('We will contact them using their selected methods.') }}</p>
              </div>
            </div>

          <button cButton class="px-4 text-white btn-info" type="submit">
            <i class="fa-solid fa-check"></i> {{ t('Update Start/End Times') }}
          </button>
        </form>
        </div>
      </div>
    </div>
  </div>



  <!-- Modal -->
  <div class="modal fade" id="copyModal" tabindex="-1" aria-labelledby="copyModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="copyModalLabel">{{ t('Copy Start/End to Workers/Groups') }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body" *ngIf="copyGroup">
          <div class="alert alert-warning" role="alert">
            <b>{{ t('Important!') }}</b> {{ t('These changes will replace the current start/end shift reminders of the chosen workers and/or workers in selected groups.') }}
          </div>
          <p>{{ t("Choose workers or groups below to copy this worker's shifts too.") }}</p>

          <form [formGroup]="copyGroup" cForm>

            <ng-container  *ngIf="okService.groups.length > 0">

              <div class="form-group row mb-2" >
                <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilGrain"></svg> {{ t('Groups') }}</label>
                <div class="col-8">

                  <ng-select [items]="okService.groups"
                            bindLabel="name"
                            bindValue="id"
                            [multiple]="true"
                            formControlName="group_ids">
                  </ng-select>
                </div>
              </div>
              <c-row>
                <c-col class="mb-3">

                  <button cButton class="text-white btn-info" type="submit" (click)="copyToGroups()" [disabled]="groups_loading">

                    <div *ngIf="!groups_loading"><i class="fa-solid fa-check"></i> {{ t('Copy the Shifts to these Groups') }} </div>
                    <div *ngIf="groups_loading"><i class="fa-solid fa-spinner fa-spin"></i> {{ t('Copy the Shifts to these Groups') }} </div>
                  </button>
                </c-col>
              </c-row>

          </ng-container>


            <div class="form-group row mb-2" >
              <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilUser"></svg> {{ t('Workers') }}</label>
              <div class="col-8">

                <ng-select [items]="okService.workers"
                          bindLabel="name"
                          bindValue="id"
                          [multiple]="true"
                          formControlName="worker_ids">
                </ng-select>

              </div>
            </div>
            <c-row>
              <c-col class="mb-3">
                <button cButton class="text-white btn-info" type="submit" (click)="copyToWorkers()" [disabled]="workers_loading">
                  <div *ngIf="!workers_loading"><i class="fa-solid fa-check"></i> {{ t('Copy the Shifts to these Workers') }} </div>
                  <div *ngIf="workers_loading"><i class="fa-solid fa-spinner fa-spin"></i> {{ t('Copy the Shifts to these Workers') }}  </div>
                </button>
              </c-col>
            </c-row>



          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div class="modal fade" id="batchModal" tabindex="-1" aria-labelledby="batchModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="batchModalLabel">{{ t('Add Multiple Start/End Times') }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body" *ngIf="batchGroup">
          <p>{{ t('Use this form to set start and end times. You can choose the start and end date, and the days of the week to apply the start times too. To remove start times choose Remove.') }}</p>

            <div class="row mb- row mb-2">
              <label class="col-sm-4 col-form-label text-end">{{ t('Dates') }}</label>
              <div class="col-sm-8">
                  <input type="text" ngxDaterangepickerMd  [locale]="{format: 'DD-MM-YYYY',displayFormat: 'D MMM YYYY'}" [autoApply]="true" [closeOnAutoApply]="true" [(ngModel)]="batch_dates" name="dates"  class="form-control"/>
              </div>
            </div>
            <form [formGroup]="batchGroup" cForm>

            <div class="form-group row mb-2" >
              <label class="col-sm-4 col-form-label text-end"> {{ t('Shift Time') }}</label>
              <div class="col-sm-8">
                <ng-select [items]="batch_times"
                bindLabel="name"
                bindValue="value"
                formControlName="time">
              </ng-select>
              </div>
            </div>

            <div class="form-group row mb-2">
              <label class="col-sm-4 col-form-label text-end">{{ t('Type') }}</label>
              <div class="col-8">
                <select  class="form-control" id="type" name="type"   formControlName="type">
                  <option value="start">{{ t('Start') }}</option>
                  <option value="end">{{ t('End') }}</option>
                </select>
              </div>
            </div>

            <div class="row mb-1">
              <div class="col">
                <input type="checkbox" class="form-check-input" formControlName="mon" name="mon"  id="mon">
                <label class="form-check-label" for="mon">&nbsp;{{ t('Monday') }}</label>
              </div>
              <div class="col">
                <input type="checkbox" class="form-check-input" formControlName="tue" name="tue"  id="tue">
                <label class="form-check-label" for="tue">&nbsp;{{ t('Tuesday') }}</label>
              </div>
            </div>

            <div class="row mb-1">
              <div class="col">
                <input type="checkbox" class="form-check-input" formControlName="wed" name="wed"  id="wed">
                <label class="form-check-label" for="wed">&nbsp;{{ t('Wednesday') }}</label>
              </div>
              <div class="col">
                <input type="checkbox" class="form-check-input" formControlName="thu" name="thu"  id="thu">
                <label class="form-check-label" for="thu">&nbsp;{{ t('Thursday') }}</label>
              </div>
            </div>

            <div class="row mb-1">
              <div class="col">
                <input type="checkbox" class="form-check-input" formControlName="fri" name="fri"  id="fri">
                <label class="form-check-label" for="fri">&nbsp;{{ t('Friday') }}</label>
              </div>
            </div>

            <div class="row mb-1">
              <div class="col">
                <input type="checkbox" class="form-check-input" formControlName="sat" name="sat" id="sat">
                <label class="form-check-label" for="sat">&nbsp;{{ t('Saturday') }}</label>
              </div>
              <div class="col">
                <input type="checkbox" class="form-check-input" formControlName="sun" name="sun" id="sun">
                <label class="form-check-label" for="sun">&nbsp;{{ t('Sunday') }}</label>
              </div>
            </div>


            <c-row>
              <c-col class="mb-3 mt-2">
                <button cButton class="text-white btn-info" type="submit" (click)="batchUpdate()" [disabled]="batch_loading">
                  <div *ngIf="!batch_loading"><i class="fa-solid fa-check"></i> {{ t('Update Start/End Times') }}  </div>
                  <div *ngIf="batch_loading"><i class="fa-solid fa-spinner fa-spin"></i> {{ t('Update Start/End Times') }}   </div>
                </button>
              </c-col>
            </c-row>


          </form>
        </div>
      </div>
    </div>
  </div>


  </ng-container>

</ng-container>
